import type {
	CampaignFunnel,
	Lane,
} from "@productlane/api/src/lib/reporting/lemlist-campaigns"

export const CAMPAIGN_COPY = {
	campaigns:
		"Pulled from lemlist every 10 minutes. Replies cover LinkedIn and email. Waiting counts leads whose next step hasn't been sent yet, including manual tasks.",
	funnel:
		"Every lead starts with a LinkedIn invite. Accepting within 7 days leads to the LinkedIn lane, otherwise the Email lane.",
	byStep: "Replies sit at the step the lead answered.",
	customShape:
		"Its steps differ from the other campaigns, so it is shown on its own.",
	notConfigured: "Campaigns load once LEMLIST_API_KEY is set on the server.",
} as const

export const laneFootnote = (
	linkedin: number,
	email: number,
	open: number,
): string =>
	`${linkedin} in the LinkedIn lane, ${email} in the Email lane. ${open} got their invite under 7 days ago.`

export const percent = (part: number, whole: number): number =>
	whole > 0 ? Math.round((part / whole) * 1000) / 10 : 0

// Names follow "Productlane | Linear | <segment> | <channels> | <date>", and
// the segment is what tells the campaigns apart.
export function campaignShortName(name: string): string {
	const parts = name.split("|").map((part) => part.trim())
	return parts.length >= 4 && parts[2] ? parts[2] : name
}

export interface StepCell {
	sent: number
	replied: number
}

export interface StepRow {
	lane: Lane
	key: string
	label: string
	cells: (StepCell | null)[]
}

export function stepRows(campaigns: CampaignFunnel[], lane: Lane): StepRow[] {
	const rows = new Map<string, StepRow>()
	campaigns.forEach((campaign, column) => {
		for (const step of campaign.lanes?.[lane].steps ?? []) {
			let row = rows.get(step.key)
			if (!row) {
				row = {
					lane,
					key: step.key,
					label: step.label,
					cells: campaigns.map(() => null),
				}
				rows.set(step.key, row)
			}
			row.cells[column] = { sent: step.sent, replied: step.replied }
		}
	})
	return [...rows.values()]
}

export function waitingTotal(campaign: CampaignFunnel): number {
	if (!campaign.lanes) return 0
	return [campaign.lanes.linkedin, campaign.lanes.email].reduce(
		(total, lane) =>
			total + lane.steps.reduce((sum, step) => sum + step.waiting, 0),
		0,
	)
}
